.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--spacing-6);
}

.flexWrapper {
  composes: flexGrow from "../../styles/layout.module.css";
}

/* Sidebar variant — wider max-width, uniform padding */
.sidebar {
  max-width: 1440px;
  padding: var(--spacing-6);
}

@media (max-width: 900px) {
  .container {
    padding-left: var(--spacing-5);
    padding-right: var(--spacing-5);
  }
}
